<div class="my-2 col-lg-10 offset-lg-1 col-12">
  <q-sendmail [Type]="'STAGE'" [Ident]="service.Stage.Ident" [model]="mailService.modelMail" (mailSend)="reinitialiser($event)"></q-sendmail>
</div>
